import {useEffect} from "react"

const ADA_HANDLE = "demo-unit-co"
const ADA_URL = "https://static.ada.support/embed2.js"
const ADA_SCRIPT_ID = "__ada"

const useAdaChatbot = (shouldInitialize = false) => {
	useEffect(() => {
		if (!shouldInitialize) {
			return
		}

		let script = document.getElementById(ADA_SCRIPT_ID) as HTMLScriptElement

		if (!script) {
			script = document.createElement("script")
			script.id = ADA_SCRIPT_ID
			script.src = ADA_URL
			script.dataset.handle = ADA_HANDLE
			script.async = true
			document.body.appendChild(script)
		} else if (window.adaEmbed) {
			try {
				window.adaEmbed.start({
					handle: ADA_HANDLE,
				})
			} catch (error) {
				console.log("Ada chatbot already running or failed to start:", error)
			}
		}
	}, [shouldInitialize])
}

export default useAdaChatbot
